var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"white--text"},[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" Matthew Lichtinger. All Rights Reserved. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }